const header = document.getElementById('site-header');
let ticking = false;

function onScroll() {
    if (!ticking) {
        window.requestAnimationFrame(() => {
            // Stuck once we've scrolled past 10px
            if (window.scrollY > 10) {
                header.classList.add('is-stuck');
            } else {
                header.classList.remove('is-stuck');
            }
            ticking = false;
        });
        ticking = true;
    }
}

window.addEventListener('scroll', onScroll, { passive: true });

// Run once on load in case the page is restored mid-scroll
onScroll();
